import { render, staticRenderFns } from "./project-selector.vue?vue&type=template&id=54d26f0c"
import script from "./project-selector.vue?vue&type=script&lang=js"
export * from "./project-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports